import { render, staticRenderFns } from "./PollCountdown.vue?vue&type=template&id=bca0cd24&lang=pug&"
import script from "./PollCountdown.vue?vue&type=script&lang=ts&"
export * from "./PollCountdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports